import { useContext } from "react";
import { RetailOrderContext } from "../context/RetailOrderContext";
import { usePrintPackingSlip } from "../api/print-packing-slip";
import { showErrorMessage } from "../../../../utils/messages";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Buffer } from 'buffer';
import { Button } from "devextreme-react/button";
import { LoadPagePanel } from "../../../../components";

export default function PackingSlipControl() {

	const navigate = useNavigate();
	const location = useLocation();

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const printPackingSlip = usePrintPackingSlip(
		order.details.retailOrderID,
		(result) => {
			const file = new Blob(
				[Buffer.from(result.packingSlip, "base64")],
				{ type: 'application/pdf' });

			const fileURL = URL.createObjectURL(file);
			window.open(fileURL);

			refetchOrder()
				.then(() => {
					const newActionRequiredID = result.activeARs.find((x) => x !== 130);
					const to = `/cfi/retail-order/${order.details.retailOrderID}/${newActionRequiredID}` +
						(!!returnUrl ? '?returnUrl=' + returnUrl : '');

					if (newActionRequiredID && location.pathname !== to) {
						navigate(to);
					}
				});
		},
		(error) => showErrorMessage(error)
	);

	return (
		<div className="packing-slip">
			<p>
				<span className="caption">Instructions:</span>
				Review the options indicated on the dealer's
				<a href={order.details.vanityOrderFormUrl ?? order.details.laminateOrderFormUrl}
					target='_blank' rel="noreferrer" className="open-form">
					{!!order.details.vanityOrderFormUrl ? "Vanity Order Form" : "Laminate Order Form"}
				</a>,
				then Print Packing Slip for store delivery.
			</p>
			<p>
				<Button
					text="Print Packing Slip"
					icon="Inscyth-Print"
					data-testid="btn-print-packing-slip"
					width={200}
					onClick={() => printPackingSlip.mutate()}>
				</Button>
			</p>
			<LoadPagePanel visible={printPackingSlip.isLoading} ></LoadPagePanel>
		</div>
	)
}
